export default __webpack_public_path__ + "static/media/img006.c685f2b3.png";